
import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '@app/services/user/user.service';
import { ModalController, Platform } from '@ionic/angular';
import { Logger, LoggingService } from 'ionic-logging-service';
import { LocaleService } from 'src/app/services/language/locale.service';

@Component({
    selector: 'app-modal',
    templateUrl: './metadata-modal.component.html',
    styleUrls: ['./metadata-modal.component.scss'],
    standalone: false
})

export class MetaDataModalComponent implements OnInit {

  @Input() dataPackage: any;
  public cloudStorage: boolean = false;
  public currentLanguage: string = null;
  public currentNetworksPage: number = 0;
  private logger: Logger;
  public metaDataItems = [];
  public wfName: string;
  name!: string;

  constructor(
    private loggingService: LoggingService,
    private localeService: LocaleService,
    public modalCtrl: ModalController,
    public platform: Platform,
    public userService: UserService
  ) {
    this.logger = this.loggingService.getLogger("[ModalComponent]");
    const methodName = "ctor";
    this.logger.entry(methodName);
  }

  ngOnInit() {
    this.startModal();
  }

  setLocale() {
    this.logger.info('setLocale()');
    this.currentLanguage = this.localeService.formatLocaleString(this.userService.userSignal().embedded.user.language);
  }

  private startModal() {
    const data = this.dataPackage;
    if (data) {
      this.metaDataItems = data.metaData || [];
      this.wfName = data.wfName || 'Capture Workflow';
      console.log('Metadata[]:', this.metaDataItems);
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
    return this.modalCtrl.dismiss(this.name, 'confirm');
  }
}
